import axios from "axios";
import authHeader from "./auth-header";

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
  send(message) {
    return axios.post(`${API_URL}/chat`, message, { headers: authHeader() });
  },
};
